import React from 'react';
import { FormattedMessage } from 'react-intl';
import HelloModal from 'common/components/hello-modal';

export default class HyperlinkInterstitialModal extends React.PureComponent {

  linkRef = React.createRef();

  handleConfirm = () => {
    this.linkRef.current.click();
    this.props.onRequestClose();
  };

  buttons = [
    {
      type: 'secondary',
      text: 'Cancel',
      onClick: this.props.onRequestClose,
      'data-qa-ref': 'interstitial-modal--cancel-btn',
    },
    {
      type: 'primary',
      text: 'Continue',
      onClick: this.handleConfirm,
      'data-qa-ref': 'interstitial-modal--continue-btn',
    },
  ];

  render() {
    const { link, isOpen, onRequestClose } = this.props;

    return (
      <HelloModal
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        width="600px"
        contentLabel="Open link"
        buttons={this.buttons}
      >
        <p>
          <FormattedMessage
            id=""
            description="message in HyperlinkInterstitial Modal informing that user is opening third pary web page in new window"
            defaultMessage="You're about to open a third party webpage in a new window." />
        </p>
        <b>{link}</b>

        {/* This <a/> tag is the one that actually does the work */}
        <a
          href={link}
          ref={this.linkRef}
          style={{ opacity: 0 }}
          target="_blank"
          rel="noopener noreferrer nofollow"
        >
          {link}
        </a>
      </HelloModal>
    );
  }
}
